export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const RESET_PASSWORD_END = 'RESET_PASSWORD_END';
export const RESET_PASSWORD_CLEAR = 'RESET_PASSWORD_CLEAR';
export const RESET_PASSWORD_SET = 'RESET_PASSWORD_SET';
